const Modal = require('./modal');
const KeyCode = require('../ui/keycode');
const template = require('./prompt.tpl').default;

module.exports = DomClass(template, function() {
	var _t = this;

	Modal.call(this);

	on(this, 'open').then(function() {
		_t.__dom.response.focus();
	});

	on(this, 'close').then(function() {
		if (_t.parentNode) _t.parentNode.removeChild(_t);
	});

	this.submitOk = function() {
		on(this, 'ok').fire(this.response);
		this.close();
	};

	this.__dom.response.onkeyup = function(e) {
		var e = new KeyCode(e || window.event);
		if (e.code == 'Enter' || e.code == 'NumpadEnter') {
			_t.submitOk();
		}
	};

	this.__dom.ok.onclick = function() {
		_t.submitOk();
	};

	this.__dom.cancel.onclick = function() {
		on(_t, 'cancel').fire(_t.response);
		_t.close();
	};

	document.body.appendChild(this);
	this.open();

});
